var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRemittance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.712 26.607-7.884 8.567.439-11.335 7.445 2.768Z",
    fill: "#4965A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.083 20.867 36.441 5.016c.121-.06.252.06.204.186l-9.19 23.728a.148.148 0 0 1-.185.087L4.1 21.141a.148.148 0 0 1-.017-.274Z",
    fill: "#A4B2CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.829 35.174-2.93-11.067L34.304 7.154 24.29 19.034l-6.108 6.884-2.353 9.256Z",
    fill: "#778CB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemittance);
export default __webpack_public_path__ + "static/media/icon_remittance.69261747060ec64b08dcf36bbd30cdec.svg";
export { ForwardRef as ReactComponent };